import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { RadixSelectControl } from "../../ui/radix-select";
import { Label } from "../../ui/label";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const SoftwareUpdate = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Package Name is required!" }));
        }
    };

    const selectChangeHandler = (value: string) => {
        dispatch(setScheduledTask({ cleanOption: value }));
        dispatch(setErrorMsg({ ...errorMsg, cleanOption: "" }));
    };

    return (
        <div className="flex flex-col gap-6">
            <div>
                <InputField
                    label="Enter Package Name"
                    name="updatePackage"
                    value={scheduledtasks?.updatePackage ?? ""}
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter package name"
                />
            </div>
            <div className="space-y-2">
                <Label className="mb-3">Device Update Clean Option</Label>
                <RadixSelectControl
                    options={[
                        { value: "None", label: "None" },
                        { value: "Db", label: "Db" },
                        { value: "Data", label: "Data" },
                        { value: "Configuration", label: "Configuration" },
                    ]}
                    value={scheduledtasks.cleanOption || "None"}
                    placeholder="__placeholder__"
                    onValueChange={selectChangeHandler}
                />
            </div>
        </div>
    );
};